import {
  faMoon,
  faSignOut,
  faUserAlt
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Avatar,
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Menu,
  MenuItem,
  Switch
} from '@mui/material';
import { useColorScheme } from '@mui/material/styles';
import { useQuery } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import {
  bindMenu,
  bindTrigger,
  usePopupState
} from 'material-ui-popup-state/hooks';
import { Link } from 'react-router';

import useAuth, { useFetchAuth } from '@/hooks/Auth.hooks';
import userAtom from '@/store/user.store';

import useStyles from './UserAccountMenu.styles';

export const UserAccountMenu = () => {
  const { mode: themeMode, setMode: setThemeMode } = useColorScheme();
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'userAccountMenu'
  });
  const { logout } = useAuth();
  const fetchMe = useFetchAuth();
  const [user] = useAtom(userAtom);
  const { classes } = useStyles();

  // Check the session and fetch user data periodically
  // Will also fetch when the window is focused to check if session is still valid
  useQuery({
    queryKey: ['me'],
    queryFn: fetchMe,
    staleTime: 60000,
    refetchOnWindowFocus: true,
    refetchInterval: 60000
  });

  const handleThemeToggle = () => {
    if (themeMode === 'light') {
      setThemeMode('dark');
      return;
    }
    setThemeMode('light');
  };

  return (
    <>
      <Avatar
        className={classes.topbarAvatar}
        {...bindTrigger(popupState)}
        src={user?.image_url || ''}
      >
        {user?.userInitials}
      </Avatar>
      <Menu
        {...bindMenu(popupState)}
        className={classes.userAccountMenu}
        autoFocus={false}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <ListSubheader className={classes.accountHeader}>
          <MenuItem component={Link} to="/user-account">
            <ListItemIcon>
              <Avatar src={user?.image_url || ''}>{user?.userInitials}</Avatar>
            </ListItemIcon>
            <ListItemText
              primary={<b>{user?.name}</b>}
              secondary={user?.email}
            />
          </MenuItem>
        </ListSubheader>

        <ListItemButton
          onClick={popupState.close}
          component={Link}
          to="/user-account"
        >
          <ListItemIcon>
            <FontAwesomeIcon icon={faUserAlt} />
          </ListItemIcon>
          <ListItemText>My Account</ListItemText>
        </ListItemButton>

        <ListItem>
          <ListItemIcon>
            <FontAwesomeIcon icon={faMoon} />
          </ListItemIcon>
          <ListItemText onClick={handleThemeToggle} sx={{ cursor: 'pointer' }}>
            Dark Mode
          </ListItemText>
          <Switch
            onClick={handleThemeToggle}
            checked={themeMode === 'dark'}
            size="small"
          />
        </ListItem>

        <Divider />

        <ListItemButton onClick={logout} sx={{ minWidth: '10rem' }}>
          <ListItemIcon>
            <FontAwesomeIcon icon={faSignOut} />
          </ListItemIcon>
          <ListItemText>Sign Out</ListItemText>
        </ListItemButton>
      </Menu>
    </>
  );
};

export default UserAccountMenu;
